import { StyleSheet, css } from 'aphrodite'
import type React from 'react'
import { useEffect } from 'react'

interface ModalProps {
  children: React.ReactNode
  onClose: () => void
  maxWidth?: number | string
}

let activeModalCount = 0

const isBrowser = typeof document !== 'undefined'

const lockBodyScroll = () => {
  if (!isBrowser) return
  if (activeModalCount === 0) {
    document.body.classList.add('modal-locked')
  }
  activeModalCount += 1
}

const unlockBodyScroll = () => {
  if (!isBrowser) return
  activeModalCount = Math.max(0, activeModalCount - 1)
  if (activeModalCount === 0) {
    document.body.classList.remove('modal-locked')
  }
}

const Modal: React.FC<ModalProps> = ({ children, onClose, maxWidth = 700 }) => {
  useEffect(() => {
    lockBodyScroll()
    return () => {
      unlockBodyScroll()
    }
  }, [])

  return (
    <div
      className={css(styles.overlay)}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose()
        }
      }}
      onKeyDown={(e) => e.key === 'Escape' && onClose()}
      role="presentation"
    >
      <div
        className={css(styles.modal)}
        style={{ overflow: 'visible', maxWidth }}
      >
        {children}
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  overlay: {
    position: 'fixed',
    top: 64, // Account for topbar height
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1100,
  },
  modal: {
    position: 'relative',
    backgroundColor: 'white',
    borderRadius: '8px',
    width: '95vw',
  },
})

export default Modal
